<ng-container *ngFor="let step of steps; index as i">
  <div class="state-container"
    [ngClass]="step.state || ''">

    <div *ngIf="i !== 0"
      class="line">
    </div>

    <div class="step">
      <accredible-icon *ngIf="step.state === stepState.VALIDATED"
        icon="check1"/>
        <span class="step-number">{{ i + 1 + ' - ' }}</span><span class="step-label">{{ step.label }}</span>
    </div>
  </div>
</ng-container>
